import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {ObracunProvizijeDocument} from "./ObracunProvizijeDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga

export const obracunProvizijeDocumentFields: IntercateKeysMap<ObracunProvizijeDocument, EntityField<ObracunProvizijeDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<ObracunProvizijeDocument>> = [
	obracunProvizijeDocumentFields.indexingNumber,
	obracunProvizijeDocumentFields.indexingDate,
	obracunProvizijeDocumentFields.documentNumber,
	obracunProvizijeDocumentFields.documentDate,
	obracunProvizijeDocumentFields.assignedTo,
	obracunProvizijeDocumentFields.clientId,
	obracunProvizijeDocumentFields.sectorId,
	obracunProvizijeDocumentFields.tags,
	obracunProvizijeDocumentFields.parentId
]

export const obracunProvizijeDocumentFieldsDescriptor: EntityFieldsDescriptor<ObracunProvizijeDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
